/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef } from 'react'
import { useSelector } from 'react-redux';
import TWEEN from "@tweenjs/tween.js";

import { const_var, params } from '../../redux/reducers/reducer'
import { getCamDstForSelectedWall } from '../../utils/Functions';

const CameraController = () => {
    // Used useRef instead of useMemo to keep a single up-to-date instance of variables accessible inside the animate loop across renders.
    const fWidth = useRef(params.p_w);
    const fLength = useRef(params.p_d);
    const fHeight = useRef(params.p_h);
    useEffect(() => {
        let val = params.p_d;
        if (params.add_front_lean && !params.add_back_lean) {
            if (params.leanStyle.front === 'standard') val += params.leanF_p_w;
            else val += params.leanF_p_d;
        } else if (!params.add_front_lean && params.add_back_lean) {
            if (params.leanStyle.back === 'standard') val += params.leanB_p_w;
            else val += params.leanB_p_d;
        } else if (params.add_front_lean && params.add_back_lean) {
            const frontAddVal = params.leanStyle.front === 'standard' ? params.leanF_p_w : params.leanF_p_d;
            const backAddVal = params.leanStyle.back === 'standard' ? params.leanB_p_w : params.leanB_p_d;
            val += Math.max(frontAddVal, backAddVal) * 2;
        }
        fLength.current = val
    }, [params.p_d, params.leanF_p_w, params.leanF_p_d, params.leanB_p_w, params.leanB_p_d, params.add_front_lean, params.add_back_lean, params.leanStyle.front, params.leanStyle.back]);

    useEffect(() => {
        let val = params.p_w;
        if (params.add_left_lean && !params.add_right_lean) {
            if (params.leanStyle.left === 'standard') val += params.lean_p_w;
            else val += params.lean_p_d * 2;
        } else if (!params.add_left_lean && params.add_right_lean) {
            if (params.leanStyle.right === 'standard') val += params.leanR_p_w;
            else val += params.leanR_p_d * 2;
        } else if (params.add_left_lean && params.add_right_lean) {
            const leftAddVal = params.leanStyle.left === 'standard' ? params.lean_p_w : params.lean_p_d;
            const rightAddVal = params.leanStyle.right === 'standard' ? params.leanR_p_w : params.leanR_p_d;
            val += Math.max(leftAddVal, rightAddVal) * 2;
        }
        fWidth.current = val;
    }, [params.p_w, params.lean_p_w, params.lean_p_d, params.leanR_p_w, params.leanR_p_d, params.add_left_lean, params.add_right_lean, params.leanStyle.left, params.leanStyle.right])

    useEffect(() => {
        fHeight.current = params.p_h + params.p_w / 2 * (params.p_r_p / 12)
    }, [params.p_w, params.p_h, params.p_r_p])

    const buildingTypeId = useSelector(state => state.reducer.OlddefaultBuilding)
    
    /** building size change */
    useEffect(() => {
        if (const_var.controls !== undefined && const_var.camera !== undefined) {
            const sectionSize = Math.max(fWidth.current, fLength.current, fHeight.current);
            let z = getCamDstForSelectedWall(sectionSize);
            let offset = z < 350 ? 1 : 0.78;
            if (z * offset >= const_var.controls?.maxDistance) z = const_var.controls.maxDistance;
            else z = z * offset;

            new TWEEN.Tween(const_var.camera?.position).to({ x: 0, y: params.p_h / 2, z}, 1000).start();
            const_var.controls.target?.set(0, params.p_h / 2, 0);
        }
    }, [
        fWidth.current, fLength.current, fHeight.current,
        params.leanF_p_w, params.leanF_p_d, params.leanStyle.front, 
        params.leanB_p_w, params.leanB_p_d, params.leanStyle.back, 
        params.lean_p_w, params.lean_p_d, params.leanStyle.left,
        params.leanR_p_w, params.leanR_p_d, params.leanStyle.right,
        const_var.isFromCompare
    ])
    
    /** building type change */
    useEffect(() => {
        if (params.p_b_t && const_var.controls !== undefined && const_var.camera !== undefined) {

            const ar = window.innerWidth / window.innerHeight;
            const offset = (((fWidth.current / 2+ fLength.current / 3) / 0.221) / (ar * ar * 1.5));
            new TWEEN.Tween(const_var.camera?.position).to({ x: offset + fWidth.current + 10, y: fHeight.current / 2, z: offset + fWidth.current  + fLength.current  + params.p_r_p / 2}, 1000).start();
            const_var.controls.target?.set(0, params.p_h / 2, 0);
        }
        
        if (const_var.isFromCompare) const_var.isFromCompare = false;
    }, [ params.toggleBuildingStyleChange, params.p_b_t, buildingTypeId, params.add_left_lean, params.add_right_lean,const_var.isFromCompare])
    
    useEffect(() => {
        animate()
    }, []);

    function animate() {
        requestAnimationFrame(animate)
        TWEEN.update()
        if(const_var.camera !== undefined && const_var.camera !== ""){
            let x = const_var.camera.position.x
            let y = const_var.camera.position.y
            let z = const_var.camera.position.z
            const radius = Math.sqrt(x * x + y * y + z * z);

            const condition = Math.sqrt(fWidth.current * fWidth.current + fHeight.current * fHeight.current + fLength.current * fLength.current) + 20;

            if(radius > condition){
                const_var.camera.near = 20
                const_var.camera.updateProjectionMatrix();
            }else{
                const_var.camera.near = 1
                const_var.camera.updateProjectionMatrix();
            }
        }
    }    
}

export default CameraController